export const WEASLEY_ELIGIBILITY_RESOURCE_OBJECT = [
  {
    filters: [
      { key: 'IsWpsFlow', value: false },
      { key: 'IsInvoiceFlow', value: false },
    ],
    operation: 'every',
    res: 'xo_lite_onboarding_ramp_phase_two',
  },
  {
    filters: [
      { key: 'IsWpsFlow', value: true },
      { key: 'IsInvoiceFlow', value: true },
    ],
    operation: 'some',
    res: 'wps_buynow_weasley',
  },
];

// Not reading res from above object, as elmo allows different values
// in name and resource
export const WEASLEY_RAMP_ELMO_EXPERIMENT_NAMES = [
  'wps_buynow_weasley',
  'xo_lite_onboarding_ramp_phase_two',
];
